import { render, staticRenderFns } from "./RscWarehousing.vue?vue&type=template&id=00b31ada&"
import script from "./RscWarehousing.vue?vue&type=script&lang=js&"
export * from "./RscWarehousing.vue?vue&type=script&lang=js&"
import style0 from "./RscWarehousing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports